import { PaymentMethod, RetryPaymentMethod, RetryPaymentStatus } from '@types-internal';

export enum TrackingType {
  CUSTOM_CLICK_TRACK = 'customClickTrack',
}

export enum AreaProduct {
  CHECKOUT = 'Checkout',
  PAYMENT = 'Payment',
}

export enum TrackingIdentifier {
  APPLE_PAY = 'ApplePay',
  ADYEN = 'Adyen',
  PAYPAL_PREVIEW_BUTTON = 'Paypal Preview Button',
}

export type AdyenEventType =
  | '3DSdisplay'
  | '3DSsubmitOK'
  | '3DSsubmitKO'
  | 'AdyenFormOK'
  | 'AdyenFormKO'
  | 'AdyenRetryPopupErrorClose';

/* The Adobe tracking event type for all operations related to account funnel
 * such as "payment method", "retry payment",... */
export type AccountEventType = 'change_payment_method' | 'retry_payment' | 'retry_payment_status';

export interface PaymentMethodChangedEventData {
  change_payment_detail: boolean;
  change_payment_method: boolean;
  new_payment_method: PaymentMethod;
}

export interface RetryPaymentEventData {
  order_id?: string;
  payment_method?: RetryPaymentMethod;
  payment_status?: RetryPaymentStatus;
}

/* The Adobe tracking event data for all operations related to account funnel. */
export type AccountEventData = PaymentMethodChangedEventData | RetryPaymentEventData;
